/* v35 (06/10/2026) : sur mobile, la photo d'une carte Mix & Match se fait glisser pour voir les suivantes
   (Pilates : portée, semelle, envers, packshot). Demande de Nicolas : « quand on slide sur mobile ça montre la photo
   d'après ». Les photos viennent du <template data-mm-gal> posé par new-mix-match-product-card.liquid.
   Un tap ouvre toujours la fiche (le lien autour de la photo) ; un glissement fait défiler sans ouvrir.
   Ordinateur : rien ne change (la 2e photo s'affiche déjà au survol). */
(function () {
  if (window.__mmGal) return; window.__mmGal = true;
  var mobile = window.matchMedia('(max-width: 989px) and (pointer: coarse)');
  function monter(media) {
    if (media.__mmGal) return;
    var t = media.querySelector('template[data-mm-gal]');
    if (!t) return;
    var imgs = t.content.querySelectorAll('img');
    if (imgs.length < 2) return;
    media.__mmGal = true;
    var bande = document.createElement('div'); bande.className = 'mm-gal';
    var points = document.createElement('div'); points.className = 'mm-gal__points'; points.setAttribute('aria-hidden', 'true');
    imgs.forEach(function (im, i) {
      var f = document.createElement('div'); f.className = 'mm-gal__f';
      var c = im.cloneNode(true); if (i === 0) c.loading = 'eager';
      f.appendChild(c); bande.appendChild(f);
      var p = document.createElement('i'); if (i === 0) p.className = 'on'; points.appendChild(p);
    });
    media.classList.add('mm-gal-on');
    media.appendChild(bande); media.appendChild(points);
    var att = null;
    bande.addEventListener('scroll', function () {
      if (att) return;
      att = requestAnimationFrame(function () {
        att = null;
        var k = Math.round(bande.scrollLeft / Math.max(1, bande.clientWidth));
        points.querySelectorAll('i').forEach(function (p, i) { p.className = i === k ? 'on' : ''; });
      });
    }, { passive: true });
  }
  function tout() {
    if (!mobile.matches) return;
    document.querySelectorAll('.product-card__media').forEach(monter);
  }
  var st = document.createElement('style');
  st.textContent =
    '.mm-gal-on>img,.mm-gal-on>picture,.mm-gal-on>.hover-img{visibility:hidden}' +
    '.mm-gal{position:absolute;inset:0;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;' +
    '-webkit-overflow-scrolling:touch;scrollbar-width:none;overscroll-behavior-x:contain;z-index:1}' +
    '.mm-gal::-webkit-scrollbar{display:none}' +
    '.mm-gal__f{flex:0 0 100%;height:100%;scroll-snap-align:start}' +
    '.mm-gal__f img{width:100%;height:100%;object-fit:var(--product-card-media-object-fit,contain);display:block}' +
    '.mm-gal__points{position:absolute;left:0;right:0;bottom:8px;display:flex;justify-content:center;gap:5px;z-index:2;pointer-events:none}' +
    '.mm-gal__points i{width:6px;height:6px;border-radius:50%;background:rgba(255,255,255,.55);box-shadow:0 0 0 1px rgba(0,0,0,.15)}' +
    '.mm-gal__points i.on{background:#fff}';
  document.head.appendChild(st);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  /* Les onglets Courtes / Hautes et le thème peuvent (re)créer des cartes : on surveille. */
  new MutationObserver(function () { clearTimeout(window.__mmGalT); window.__mmGalT = setTimeout(tout, 120); })
    .observe(document.body, { childList: true, subtree: true });
  mobile.addEventListener && mobile.addEventListener('change', tout);
})();
